import parse from 'html-react-parser';

export const parseHtmlOrString = content => parse(`${content || ''}`);
